import React from 'react'
import styled from 'styled-components';
import { useState, useEffect, useRef } from 'react';
import JoditEditor from 'jodit-react';
import { useSelector } from 'react-redux'
import useAuth from '../../../../features/hooks/useAuth'
import { useGetAssetMastersQuery } from '../../../../features/assetmasterApiSlice/assetmasterApiSlice'
import { useGetassetReqQuery, useUpdateassetReqMutation, useUpdateassetReqstatusMutation } from '../../../../features/assetrequest/assetReqApiSlice'
import { useGetUsersQuery, useAddUserAssetsMutation } from '../../../../features/users/usersApiSlice';
import { useGetofficesQuery } from '../../../../features/offices/officesApiSlice';
import { useGetAssetsFinalQuery, useUpdateAddAssetFinalMutation, useUpdateAssetintransitMutation } from '../../../../features/addassets/addassetfinalApiSlice'
import Divider from '@mui/material/Divider';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import { useGetStoreOfficesQuery } from '../../../../features/storeoffices/storeofficesApiSlice'
import ReactTooltip from "react-tooltip";
import moment from 'moment'
import { HeadingWrap, Span, CommonButton, PreDataWrap, IntReqWrapper, AddRemarkButton, BackButtonSpan, StoreNameCont, ExtReqWrapper, PopupButton } from '../../../../Styles/CommonStyles'

const Container = styled.div``
const Wrapper = styled.div`

display: flex;
flex-direction: column;
`
const AssetWrapper = styled.div``
const AssetItemWrapper = styled.div`
display: flex;
margin: 10px;
align-items: center;
font-size: 20px;
`
const AssetItemsWrap = styled.span`
margin-right: 30px;
font-size: 20px;
`
const TextWrapper = styled.div`
font-size: 20px;
`
const UserNameContainer = styled.div`
padding-right: 30px;
font-size: 20px;
`
const PreDataCont = styled.div`
`
const FormContainer = styled.div``
const FormWrapper = styled.div``

const TextFormCont = styled.div``

const FormItemsCont = styled.div`
display: flex;
align-items: center;
`
const InputFieldWrap = styled.div``
const SelectContainer = styled.div`
display: flex;
align-items: center;
`
const Option = styled.option`
font-weight: 100;
`
const Styledlabel = styled.label`
font-size: 20px;
font-weight: 200;
`
const CatSelect = styled.select`
width: 30%;
height: 35px;
`
const SubcatSelect = styled.select`
width: 30%;
height: 30px;
`
const AssetNameselCon = styled.div`
display: flex;
height: 5vh;
`
const TimeAndNameCont = styled.div`
display: flex;
font-size: 20px;
justify-content: space-between;
`
const TimeWrapper = styled.div`
font-size: 20px;
`
const NoteCountCont = styled.div`
font-size: 22px;
font-weight: 600;
`
const BackArrowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 20px;
  cursor: pointer;
`
const OldAssetsCont = styled.div``
const OldAssetWrapper = styled.div`
display: flex;
`
const OldItemsWrapper = styled.div`
display: flex;
margin-right: 40px;
margin-bottom: 20px;
`
const ItemContainer = styled.div`
display: flex;
background-color: #aae2e4;
width: 50vw;
align-items: center;
justify-content: space-between;
margin-top: 20px;
margin-bottom: 2px;
padding-top: 5px;
padding-bottom: 5px;
`
const Itemwrapper = styled.div`
display: flex;
width: 14vw;
`
const ItemLabelwrap = styled.div`
font-weight: 600;
margin-right: 30px;
font-size: 25px;
`
const ItemValWarap = styled.div`
display: flex;
justify-content: center;
align-items: center;
font-size: 20px;
`
// table style
const tableStyle = {
    width: '53%',
    borderCollapse: 'collapse',
    marginTop: '20px',
};

const thTdStyle = {
    border: '1px solid #ddd',
    padding: '8px',
    textAlign: 'left',
    fontSize: '20px'
};

const thStyle = {
    backgroundColor: '#aae2e4',
    fontSize: '23px'
};

const evenRowStyle = {
    backgroundColor: '#f9f9f9',
};


const AMIssueSentForm = ({ reqid, setChangepage }) => {
    const [field, setField] = useState([{ catName: "", assetName: "", quantity: "" }])
    const [CatIndex, setCatIndex] = useState([])
    const [content, setContent] = useState('');
    const [remarkButtonClicked, setRemarkButtonClicked] = useState(false)
    const editor = useRef(null);
    const [issueClicked, setIssueClicked] = useState(false)
    const [selectedOptions, setSelectedOptions] = useState({});
    const [storeOffice, setStoreOffice] = useState('')

    // logged in user info
    const { id, email, designation, designationSuffix, numSuffix, office, roles } = useAuth()
    let user_current_office = (useSelector((state) => state.office.off))
    let user_current_role_array = roles[user_current_office]

    // store offices 
    const {
        data: allstoreoffices
    } = useGetStoreOfficesQuery('allstorelists', {
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    });

    let tempstoredata = allstoreoffices ? Object.values(allstoreoffices?.entities) : []
    let allstoresdata = tempstoredata

    //assetmaster call
    const {
        data: assetmasters,
        isLoading: assetmastLoad,

    } = useGetAssetMastersQuery('assetmasterlist', {
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    });

    let tempdata = assetmasters ? Object.values(assetmasters?.entities) : []
    let data = tempdata

    //All assets in store
    const {
        data: allassets,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetAssetsFinalQuery('allassetlist', {
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    });

    let allAssetsData = allassets ? Object.values(allassets?.entities) : []

    //get single assets

    const { getSingleasset } = useGetAssetsFinalQuery('allassetlist', {
        selectFromResult: ({ data }) => ({
            getSingleasset: data?.entities
        }),
    })


    // all users call 
    const {
        data: usersdata,
        isLoading: usersLoading,

    } = useGetUsersQuery('userslist', {
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    });

    let users = usersdata ? Object.values(usersdata?.entities) : []

    //Single user call
    const { getSingleuser } = useGetUsersQuery('userslist', {
        selectFromResult: ({ data }) => ({
            getSingleuser: data?.entities
        }),
    })

    //Single Request call
    const { getSingleRequest } = useGetassetReqQuery('allassetReqlist', {
        selectFromResult: ({ data }) => ({
            getSingleRequest: data?.entities
        }),
    })

    // call the req doc which is clicked
    let singleReq_data = getSingleRequest && getSingleRequest[reqid]

    // Asset_managers call/filter
    let store_off = singleReq_data?.req_store

    //set selected store office
    useEffect(() => {
        setStoreOffice(store_off)
    }, [])

    // find applicable categories based on store of the request
    let selectedStoreDoc = allstoresdata.filter(elm => elm.storeoffice === store_off)
    let applCatarray = selectedStoreDoc[0]?.ApplAssetCateg

    // get last assets blocked by assetmanager level-1
    // first find lastindex
    let lastblockedassetind = singleReq_data?.req_data.findLastIndex(elm => elm.blocked_assets)
    let lastblockedassetsObj = singleReq_data?.req_data[lastblockedassetind]
    let lastBlockedAssetsArray = lastblockedassetsObj?.blocked_assets

    // all office call
    const {
        data: allofficedata,
        isLoading: allofficeLoad,
    } = useGetofficesQuery('officelist', {
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    });

    //reqUpdate mutation
    const [updateReq, { isLoading: updateaddassetloading }] = useUpdateassetReqMutation()

    //reqStatus Update Mutation
    const [updateReqStatus, { isLoading: updateaddassetreqStatusloading }] = useUpdateassetReqstatusMutation()

    let tempallofficedata = allofficedata ? Object.values(allofficedata?.entities) : []
    const officedata = tempallofficedata

    //get last selected assets by user 
    let index_last_assets = getSingleRequest[reqid]?.req_data.findLastIndex(elm => elm.assets_details !== undefined)
    let lastSubAssetArray = getSingleRequest[reqid]?.req_data[index_last_assets].assets_details

    //selcted assets IDs array
    let selectedAssetsIdArray = Object.values(selectedOptions)?.map(elm => elm?.map((elem) => { return elem.value })).flat()
    let selectedassets = selectedAssetsIdArray.map(elm => { return getSingleasset && getSingleasset[elm] })

    // validator for assetQuantity
    let totalAssetsQuantity = lastSubAssetArray.map(elm => { return Number(elm.quantity) }).reduce((a, b) => a + b, 0)

    // sent back to unithead  
    // find unit head id of useroffice (request creator office)
    let useroffice = officedata?.filter(elm => elm.name === singleReq_data?.req_creator.office)
    let unitHead_id = useroffice[0]?.unitHead
    let requestCreatorOff = singleReq_data?.req_creator.office

    let sendtounitHeadObj = { id: unitHead_id, name: getSingleuser && getSingleuser[unitHead_id]?.name, office: requestCreatorOff, designation: getSingleuser && getSingleuser[unitHead_id]?.designation[requestCreatorOff], designationSuffix: getSingleuser && getSingleuser[unitHead_id]?.designationSuffix[requestCreatorOff], numSuffix: getSingleuser && getSingleuser[unitHead_id]?.numSuffix[requestCreatorOff] }


    // sendto Assetmanager level -2 obj logic building
    // find asset manager level-II ID
    let assetManagerL2Id = selectedStoreDoc[0]?.roleUsers.level2approver
    //sent to Assetmanager level-II obj

    // sent to assetmanager level-II buttton data


    //sent back to assetmanager level-I obj
    // find asset manager level-I ID
    let assetManagerL1Id = selectedStoreDoc[0]?.roleUsers.level1approver

    //sent to Assetmanager level-1 obj
    let sendtoassetManagerL1Obj = { id: assetManagerL1Id, name: getSingleuser && getSingleuser[assetManagerL1Id]?.name, office: user_current_office, designation: getSingleuser && getSingleuser[assetManagerL1Id]?.designation[user_current_office], designationSuffix: getSingleuser && getSingleuser[assetManagerL1Id]?.designationSuffix[user_current_office], numSuffix: getSingleuser && getSingleuser[assetManagerL1Id]?.numSuffix[user_current_office] }


    //senttoUser object for sending issued assets to the user.
    //find the user ID of request creator
    // filter users in the office of request creator
    let requestCreatorofficeuserslist = users?.filter(elm => ((elm.office.mainCharge === singleReq_data?.req_creator.office) || (elm.office.additionalCharge.includes(singleReq_data?.req_creator.office))))
    // filter the request creator
    let reqCreatorobj = requestCreatorofficeuserslist.filter(elm => (elm.designation[singleReq_data?.req_creator.office] === singleReq_data?.req_creator.designation) && (elm.designationSuffix[singleReq_data?.req_creator.office] === singleReq_data?.req_creator.designationSuffix) && (elm.numSuffix[singleReq_data?.req_creator.office] === singleReq_data?.req_creator.numSuffix))

    let reqCreator_id = reqCreatorobj[0]._id


    // assets in transit/ nont-ransit logic based on blocked and unblocked assets by assetmanager level-1
    let oldassetsarray = lastBlockedAssetsArray
    let newselectedArray = selectedAssetsIdArray

    //filter old asset array which are not common in newselected
    let myArray = oldassetsarray?.filter((el) => !newselectedArray.includes(el));

    // call the req doc which is clicked
    let lastIndex = singleReq_data.req_data?.findLastIndex(elem => (elem.sent_by.office === user_current_office) && (elem.sent_by.designation === designation[user_current_office]) && (elem.sent_by.designationSuffix === designationSuffix[user_current_office]))

    let splicedArray = singleReq_data.req_data?.slice(0, lastIndex + 1)

    return (
        <Container>
            <BackArrowContainer onClick={() => setChangepage([true, false, false, false])}><ArrowLeftIcon /><BackButtonSpan >Back to Category Table</BackButtonSpan></BackArrowContainer>
            <Wrapper>
                <PreDataCont>
                    {/* <StoreNameCont>Requested Store: {store_off}</StoreNameCont> */}
                    {splicedArray?.map((elm, ind) =>
                        <PreDataWrap key={ind}>
                            <HeadingWrap>
                                <NoteCountCont>Note-{ind + 1}</NoteCountCont>
                            </HeadingWrap>
                            {elm.assets_details && <div style={{margin: '15px'}}><span style={{fontSize: '20px'}}>Requisite Asset Details</span></div>}
                            {elm.assets_details && elm.assets_details?.map((elem, index) => <AssetItemWrapper key={index}>
                                <ItemContainer>
                                    <Itemwrapper>
                                        <ItemLabelwrap>
                                            Category:
                                        </ItemLabelwrap>
                                        <ItemValWarap>
                                            {elem.catName}
                                        </ItemValWarap>
                                    </Itemwrapper>
                                    <Itemwrapper>
                                        <ItemLabelwrap>
                                            AssetName:
                                        </ItemLabelwrap>
                                        <ItemValWarap>
                                            {elem.assetName}
                                        </ItemValWarap>
                                    </Itemwrapper>
                                    <Itemwrapper>
                                        <ItemLabelwrap>
                                            Quantity:
                                        </ItemLabelwrap>
                                        <ItemValWarap>
                                            {elem.quantity}
                                        </ItemValWarap>
                                    </Itemwrapper>
                                </ItemContainer>
                                <Divider />
                                {/* <AssetItemsWrap> Asset Category : {elem.catName}</AssetItemsWrap>
                                <AssetItemsWrap>Asset Name: {elem.assetName}</AssetItemsWrap>
                                <AssetItemsWrap>Quantity : {elem.quantity}</AssetItemsWrap> */}
                            </AssetItemWrapper>)}
                            {elm.blocked_assets && getSingleasset && <OldAssetsCont>
                                <Span> Proposed assets details: </Span>
                                {elm.blocked_assets && <OldAssetWrapper>
                                    <table style={tableStyle}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...thTdStyle, ...thStyle }}>Assets</th>
                                                <th style={{ ...thTdStyle, ...thStyle }}>OEM Tags</th>
                                                <th style={{ ...thTdStyle, ...thStyle }}>OEM/Brand</th>
                                                <th style={{ ...thTdStyle, ...thStyle }}>Purchase Date</th>
                                                <th style={{ ...thTdStyle, ...thStyle }}>Warranty Date</th>
                                                <th style={{ ...thTdStyle, ...thStyle }}>Specifications</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {elm.blocked_assets?.map(element => { return getSingleasset && getSingleasset[element] })?.map((row, index) => (
                                                <tr key={index} style={(index + 1) % 2 === 0 ? evenRowStyle : null}>
                                                    <td style={thTdStyle}>{row.name}</td>
                                                    <td style={thTdStyle}>{row.oem_tag}</td>
                                                    <td style={thTdStyle}>{row.oem}</td>
                                                    <td style={thTdStyle}>{moment(row.purchase_date).format('DD/MM/YYYY')}</td>
                                                    <td style={thTdStyle}>{moment(row.warrantyexp_date).format('DD/MM/YYYY')}</td>
                                                    <td style={thTdStyle}><div className="App">
                                                        <div data-tip data-for={row._id}>
                                                            Hover here to view Specifications
                                                        </div>
                                                        <ReactTooltip id={row._id} place="top" effect="solid">
                                                            <div>
                                                                {Object.entries(row.specification).map(([key, val]) => <h4 key={key}>{key}: {val}</h4>)}
                                                            </div>
                                                        </ReactTooltip>
                                                    </div></td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </OldAssetWrapper>}
                            </OldAssetsCont>}
                            <TextWrapper>
                                Remark: <div dangerouslySetInnerHTML={{ __html: elm.Text }} />
                            </TextWrapper>
                            <TimeAndNameCont>
                                <TimeWrapper>
                                    {getSingleRequest[reqid]?.req_data[getSingleRequest[reqid]?.req_data.length - 1].time_stamp}
                                </TimeWrapper>
                                <UserNameContainer>
                                    {`${getSingleRequest[reqid]?.req_data[ind].sent_by?.name?.firstName} ${getSingleRequest[reqid]?.req_data[ind].sent_by?.name?.middleName} ${getSingleRequest[reqid]?.req_data[ind].sent_by?.name?.lastName}-${getSingleRequest[reqid]?.req_data[ind].sent_by?.office}-${getSingleRequest[reqid]?.req_data[ind].sent_by?.designation} ${getSingleRequest[reqid]?.req_data[ind].sent_by?.designationSuffix}`}
                                </UserNameContainer>
                            </TimeAndNameCont>
                        </PreDataWrap>)}
                </PreDataCont>
            </Wrapper>
        </Container>
    )
}

export default AMIssueSentForm